// INICIO Esenciales React
import React from "react";
import { Routes, Route } from "react-router-dom";
// FIN Esenciales React

// INICIO Plantilla de Sitio
import NavbarTop from "../layout/NavbarTop";
import NavbarBottom from "../layout/NavbarBottom";
// FIN Plantilla de Sitio

// INICIO Paginas de Dashboard
import PanelRoutes from "../routes/PanelRoutes";

const Panel = () => {
  return (
    <div className="page-wrapper">
      <NavbarTop />
      <NavbarBottom />
      <PanelRoutes />
    </div>
  );
};

export default Panel;
